import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { ArrowLeft } from "lucide-react";

function fmtDate(d) {
  try { return new Date(d + "T00:00:00").toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" }); }
  catch { return d; }
}

export default function NewsDetail() {
  const { id } = useParams();
  const [n, setN] = useState(null);
  useEffect(() => { api.get(`/news/${id}`).then((r) => setN(r.data)).catch(() => {}); }, [id]);
  if (!n) return <div className="py-20 text-center text-muted-foreground">Loading…</div>;

  return (
    <div className="max-w-2xl mx-auto" data-testid="news-detail-page">
      <Link to="/news" className="inline-flex items-center gap-1.5 text-sm text-muted-foreground hover:text-primary mb-6"><ArrowLeft className="h-4 w-4" /> Firm News</Link>
      <div className="flex items-center gap-3 mb-3">
        <span className="text-[10px] uppercase tracking-wider font-semibold px-2 py-0.5 bg-primary/10 text-primary rounded-sm">{n.category}</span>
        <span className="text-xs text-muted-foreground">{fmtDate(n.date)} · {n.author}</span>
      </div>
      <h1 className="font-display font-extrabold text-3xl tracking-tight">{n.title}</h1>
      <div className="prose prose-sm dark:prose-invert mt-6 text-foreground/90 whitespace-pre-line leading-relaxed">{n.body}</div>
    </div>
  );
}
